<app-menu-bar></app-menu-bar>

<div class="legacy-page">
    <div class="legacy-card">
        @switch (state) {
            @case ('resolving') {
                <span class="spinner" role="status" aria-label="Preparing your download"></span>
                <span class="title">Preparing your download…</span>
            }
            @case ('started') {
                <div class="check">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M4 12.5l5 5L20 6.5" />
                    </svg>
                </div>
                <span class="title">Your download has started</span>
                @if (filename) {
                    <span class="text">{{ filename }}</span>
                }
                <span class="text">If nothing happened, check your browser's downloads.</span>
                <button type="button" class="home-btn" (click)="goHome()">Go to the FYES site</button>
            }
            @case ('not-found') {
                <span class="title">This file is no longer available</span>
                <span class="text">
                    The link you followed points to a file we no longer host. It may have been
                    replaced or removed.
                </span>
                <button type="button" class="home-btn" (click)="goHome()">Go to the FYES site</button>
            }
            @default {
                <span class="title">Something went wrong</span>
                <span class="text">We couldn't prepare this download. Please try again in a moment.</span>
                <button type="button" class="home-btn" (click)="goHome()">Go to the FYES site</button>
            }
        }
    </div>
</div>

<app-footer></app-footer>
